if (!customElements.get('bz-share')) {
  class BZShare extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.share_btn');
      this.msg = this.querySelector('.msg');
      if (!this.button || !this.msg) return;
      this.button.addEventListener('click', () => this.share());
    }
    share() {
      const url = location.href;
      if (navigator.share) {
        navigator.share({ title: document.title, url })
          .catch(() => this.copy(url));
      } else {
        this.copy(url);
      }
    }
    copy(url) {
      navigator.clipboard.writeText(url).then(() => this.toast());
    }
    toast() {
      this.msg.style.display = 'block';
      setTimeout(() => (this.msg.style.display = 'none'), 2000);
    }
  }
  customElements.define('bz-share', BZShare);
}
